import { oc } from "@orpc/contract";
import { z } from "zod";

export const LookupEmailInputSchema = z.object({
  email: z.string().email(),
});

const TenantUserSummarySchema = z.object({
  tenantUserId: z.string().uuid(),
  name: z.string(),
  organizations: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
});

export const LookupEmailOutputSchema = z.discriminatedUnion("status", [
  z.object({ status: z.literal("available") }),
  z.object({
    status: z.literal("existing_in_tenant"),
    tenantUser: TenantUserSummarySchema,
    alreadyInThisOrg: z.boolean(),
  }),
  z.object({ status: z.literal("exists_other_tenant") }),
]);

export const lookupEmailContract = oc
  .input(LookupEmailInputSchema)
  .output(LookupEmailOutputSchema)
  .route({ method: "POST" });

export const organizationMembersContracts = {
  lookupEmail: lookupEmailContract,
} as const;

export type LookupEmailInput = z.infer<typeof LookupEmailInputSchema>;
export type LookupEmailOutput = z.infer<typeof LookupEmailOutputSchema>;
